"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplifyServerContextError = void 0;
const AmplifyError_1 = require("./AmplifyError");
/**
 * @deprecated The legacy server-context machinery has been removed in favor of
 * the singleton-free {@link AmplifyContext} model. This error type is retained
 * only for backwards compatibility of existing `catch`/re-export paths and will
 * be removed in a future major version.
 */
class AmplifyServerContextError extends AmplifyError_1.AmplifyError {
    constructor({ message, recoverySuggestion, underlyingError, }) {
        super({
            name: 'AmplifyServerContextError',
            message,
            recoverySuggestion,
            underlyingError,
        });
    }
}
exports.AmplifyServerContextError = AmplifyServerContextError;
